
class InUtils {

  /**
   * Валидирует индийский PAN (Permanent Account Number)
   * @param {string} value - PAN для валидации
   * @returns {string|null} Ошибка валидации или null если корректный
   */
  static validatePAN(value) {
    if (typeof value !== 'string') return null;
    if (value.length !== 10) return 'PAN должен быть 10 символов длиной';
    if (!/^[A-Z]{5}\d{4}[A-Z]$/g.test(value)) return 'Некорректный PAN';
    return null;
  }
}

export default InUtils;